import React from 'react';
import './DiscoverSpace.css'
const DiscoverSpace = () => {
    return (
        <div className='discover-univercel'>
        <div className="container">
            <div className="row">
            <h3>Discover Univerce</h3>
                <div className="col-md-4">
                <div className="misson-space">
                <img src="https://i.ibb.co/6gTY45P/s1.png" alt="space1" />
                    <h4>Mission Bongo</h4>
                    <p>At PIAP Space, we believe that we can make Space and Earth cleaner, engineering, and delivering top-quality robotics solutions.</p>
                </div>
                </div>
                <div className="col-md-4">
                <div className="misson-space">
                <img src="https://i.ibb.co/f12JbzN/s2.png" alt="space2" />
                    <h4>Mission BD</h4>
                    <p>At PIAP Space, we believe that we can make Space and Earth cleaner, engineering, and delivering top-quality robotics solutions.</p>
                </div>
                </div>
                <div className="col-md-4">
                <div className="misson-space">
                <img src="https://i.ibb.co/KGHhK1K/s3.png" alt="space3" />
                    <h4>Mission 11</h4>
                    <p>At PIAP Space, we believe that we can make Space and Earth cleaner, engineering, and delivering top-quality robotics solutions.</p>
                </div>
                </div>
            </div>
        </div>
            
        </div>
    );
};

export default DiscoverSpace;